export default __webpack_public_path__ + "25f2df863ae486f768597a32cbd4c44c.png";